module.exports = __webpack_public_path__ + "static/media/address_1.37bf70e3.png";